import { store } from '../../../redux/store'
import { setHolidayNoticeModalOpen, setHolidayNoticeModalData } from './redux/holidayNoticeModalSlice'

export const showHolidayNoticeModal = (data = {}) => {
    console.log('Attempting to show holiday notice modal with data:', data)
    store.dispatch(setHolidayNoticeModalData(data))
    store.dispatch(setHolidayNoticeModalOpen(true))
    console.log('Holiday notice modal state updated')
}

export const hideHolidayNoticeModal = () => {
    store.dispatch(setHolidayNoticeModalOpen(false))
}

// Check if we should show the holiday notice
export const shouldShowHolidayNotice = (isLoginEvent = false, forceCheck = false) => {
    const currentDate = new Date()
    const endDate = new Date('2026-01-05T23:59:59') // January 5, 2026

    // Check if user has already seen the notice today
    const lastShown = localStorage.getItem('holidayNoticeLastShown')
    const today = new Date().toDateString()

    const dateCheck = currentDate < endDate

    // Show if:
    // 1. Force check is true (for testing)
    // 2. It's a login event (always show on login)
    // 3. Haven't shown today and it's not a login event (once per day for other cases)
    const shouldShow = forceCheck ||
        (dateCheck && isLoginEvent) ||
        (dateCheck && !isLoginEvent && lastShown !== today)

    console.log('Holiday Notice Debug:', {
        currentDate,
        endDate,
        lastShown,
        today,
        isLoginEvent,
        forceCheck,
        dateCheck,
        shouldShow,
        behavior: isLoginEvent ? 'Login event - always show' : 'Regular check - once per day'
    })

    return shouldShow
}

export const markHolidayNoticeShown = () => {
    // Mark as shown today (for non-login events)
    const today = new Date().toDateString()
    localStorage.setItem('holidayNoticeLastShown', today)
    console.log('Holiday notice dismissed - marked as shown today')
}

// Helper function to reset the holiday notice for testing
export const resetHolidayNotice = () => {
    localStorage.removeItem('holidayNoticeLastShown')
    sessionStorage.removeItem('holidayNoticeShownThisSession') // Clean up old items
    console.log('Holiday notice localStorage cleared')
}

// Force show the holiday notice for testing
export const forceShowHolidayNotice = () => {
    console.log('Force showing holiday notice modal')
    showHolidayNoticeModal({
        title: 'Holiday Notice',
        message: 'Our offices will close at end of business on Thursday, 18 December 2025, and will reopen on Monday, 5 January 2026. All deposits and withdrawals submitted during this period will be processed on 5 January 2026.'
    })
}

// Add functions to window for easy testing in browser console
if (typeof window !== 'undefined') {
    window.holidayNoticeDebug = {
        shouldShow: shouldShowHolidayNotice,
        shouldShowLogin: () => shouldShowHolidayNotice(true), // Simulate login event
        shouldShowForce: () => shouldShowHolidayNotice(false, true), // Force show
        forceShow: forceShowHolidayNotice,
        reset: resetHolidayNotice,
        hide: hideHolidayNoticeModal
    }
}
